package com.esoris.kmpmoout.core.app_dummy

object AppDummy {

    val userId: String = "f7cc42c4-21ec-4b99-8280-e922e3e3aba4"

}